<div class="flex flexWrap--wrap flexJustify--between flexAlign--center mt-0050"
     [formGroup]="formGroup"
     *ngIf="formGroup">

  <ng-container>
    <mat-form-field class="col__ col__sm--65 col__md--50">
      <mat-label>Phone number</mat-label>
      <mat-icon fontSet="flag-icon"
                [fontIcon]="flagIcon"
                matIconPrefix></mat-icon>
      <app-mat-phone-input formControlName="number"
                           [placeholder]="placeholder"
                           [campaignCountry]="defaultCountryCode"
                           (countryCodeEvent)="updateFlagIcon($event)"></app-mat-phone-input>
    </mat-form-field>
  </ng-container>

  <mat-form-field class="col__ col__xs--45 col__sm--30 col__md--20"
                  [hideRequiredMarker]="true">
    <mat-label>Ext</mat-label>
    <input matInput
           type="tel"
           data-test-id="phoneExtInput"
           formControlName="ext"
           autocomplete="off">
    <app-input-error [formControlItem]="formGroup.controls.ext"></app-input-error>
  </mat-form-field>
  <mat-form-field data-test-id="phoneTypeSelect"
                  class="col__ col__xs--50 col__sm--100 col__md--25"
                  [hideRequiredMarker]="true">
    <mat-label>Type</mat-label>
    <mat-select placeholder="Type"
                formControlName="numberType"
                [disableRipple]="true">
      <mat-option [value]="'cell'">Mobile</mat-option>
      <mat-option [value]="'home'">Home</mat-option>
      <mat-option [value]="'work'">Work</mat-option>
    </mat-select>
    <app-input-error [formControlItem]="formGroup.controls.numberType"></app-input-error>
  </mat-form-field>


  <div class="col__ col__xs--75  col__md--75 bot-0025">
    <div class="d-block d-inline-block--sm w-100 w-auto--sm mb-0050 mb-0--ps mr-0100">
      <mat-checkbox class="d-inline-block mr-0100"
                    formControlName="verified"
                    data-test-id="phoneVerifiedCheckbox"
                    disableRipple>Confirmed</mat-checkbox>
    </div>

    <div class="d-block d-inline-block--sm">
      <mat-checkbox class="d-inline-block"
                    formControlName="subscribed"
                    disableRipple>Subscribed</mat-checkbox>
    </div>
  </div>

</div>
